import React from "react";
import Post from "./Post";
import MixpanelService from "../utils/MixpanelService";
import FileAttachment from "./shared/FileAttachment";

const SheetJSFT = [".xlsx", ".xls", ".csv"];

const DataInput = (props) => {
  const handleChange = (e) => {
    const attachments = Array.from(e.target.files || []);
    if (!attachments.length) return;

    MixpanelService.track("Submission Started");
    attachments.forEach((attachment) => {
      props.handleFile(attachment);
    });

    e.target.value = "";
  };

  const handleRemove = (event, fileId) => {
    event.stopPropagation();
    document.getElementById("submissionAttachments").value = "";
    props.removeSelectedFile(fileId);
  };

  const getAttachmentHighlightClass = (attachment) => {
    if (!attachment.hasValidRows)
      return "attachments__tile attachments__tile--med attachments__tile--space attachments__tile--no-rows";
    if (attachment.hasErrors)
      return "attachments__tile attachments__tile--med attachments__tile--space attachments__tile--warning";
    return "attachments__tile attachments__tile--med attachments__tile--space attachments__tile--valid";
  };

  const getAttachmentStatusEl = (attachment) => {
    if (!attachment.hasValidRows)
      return (
        <div className="attachments__tile__status-tag attachments__tile__status-tag--no-rows">
          No Rows for Submission
        </div>
      );
    if (attachment.hasErrors)
      return (
        <div className="attachments__tile__status-tag attachments__tile__status-tag--warning">
          Validation Alerts
        </div>
      );
    return <div className="attachments__tile__status-tag">Good</div>;
  };

  const renderAttachments = () => {
    return props.attachments.map((attachment) => (
      <FileAttachment
        key={attachment.fileId}
        attached={attachment}
        highlightClassName={getAttachmentHighlightClass(attachment)}
        statusElement={getAttachmentStatusEl(attachment)}
        fieldMappingGroups={props.fieldMappingGroups}
        selectedMapping={attachment.mappingName}
        expandFileHeaders={props.expandFileHeaders}
        onRemove={(event) => handleRemove(event, attachment.fileId)}
        onSetMapping={(attachment, mapping) => props.setSelectedMapping(attachment, mapping)}
      />
    ));
  };

  return (
    <>
      <Post
        organization={props.organization}
        data={props.attachments}
        ndcList={props.ndcList}
        submissionPath={props.submissionPath}
        submissionName={props.submissionName}
        setSubmissionName={props.setSubmissionName}
        fieldMappingGroups={props.fieldMappingGroups}
        submissionType={props.submissionType}
        clearAttachments={props.reset}
        setLeavePageLink={props.setLeavePageLink}
        claimsDeidentified={props.claimsDeidentified}
      />
      <div className="draw__section__header draw__section__header--sm draw__section__header--border">
        <div className="flex flex-column gap--4">
          <div className="t--sm t--subtitle t--upcase t--500">Get Started</div>
          <div className="draw__section__title t--700">Attach files to Submit</div>
        </div>
        <div className="draw__section__caddy">
          <div
            className={
              props.attachments?.length
                ? "button button--blue"
                : "button button--blue btn--pulse--loud"
            }
            onClick={() => document.getElementById("submissionAttachments").click()}
          >
            Attach
          </div>
          <input
            type="file"
            multiple
            style={{ display: "none" }}
            className="form-control"
            id="submissionAttachments"
            accept={SheetJSFT}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="draw__section__container">{renderAttachments()}</div>
    </>
  );
};

export default DataInput;
